<p class="file-name">
  <mat-icon *ngIf="context.storageObjectType === StorageObjectType.File" class="document-icon notranslate"
            [svgIcon]="context.metaFileLink | mediaFileIcon">
  </mat-icon>
  {{getFileName()}}
</p>
<mat-nav-list>
  <a mat-list-item (click)="select(FileMenuOption.View, $event)">
    <mat-icon mat-list-icon class="notranslate">visibility</mat-icon>
    <span mat-line>View</span>
  </a>
  <a mat-list-item (click)="select(FileMenuOption.Download, $event)">
    <mat-icon mat-list-icon class="notranslate">get_app</mat-icon>
    <span mat-line>Download</span>
  </a>
</mat-nav-list>
